import React from 'react';

function FDPQPlaceHolder() {
    return (
        <div className="fdpq-section margin-top-3">
            <div className="fdpq-header padding-vertical-3 padding-horizontal-4">
                <div className="skeleton__loading">
                    <div className="skeleton__headline skeleton__placeholder fdpq-title" />
                </div>
            </div>
            <div className="fdpq-subtitle padding-4">
                <div className="skeleton__loading">
                    <div className="skeleton__headline skeleton__placeholder fdpq-description" />
                </div>
            </div>
            <div className="fdpq-form padding-top-5 padding-horizontal-4 padding-bottom-4">
                <div className="fdpq-form-row">
                    <div className="skeleton__loading">
                        <div className="skeleton__headline skeleton__placeholder fdpq-select" />
                    </div>
                </div>
                <div className="fdpq-form-row">
                    <div className="skeleton__loading">
                        <div className="skeleton__headline skeleton__placeholder fdpq-select" />
                    </div>
                </div>
                <div className="fdpq-form-row">
                    <div className="skeleton__loading">
                        <div className="skeleton__headline skeleton__placeholder fdpq-select" />
                    </div>
                </div>
                <div className="fdpq-form-row fdpq-zip-row">
                    <div className="fdpq-zip-input">
                        <div className="skeleton__loading">
                            <div className="skeleton__headline skeleton__placeholder fdpq-zip" />
                        </div>
                    </div>
                    <div className="fdpq-button">
                        <div className="skeleton__loading">
                            <div className="skeleton__headline skeleton__placeholder fdpq-cta" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FDPQPlaceHolder;
